const initialState = {};

export const charityRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
